import { render, staticRenderFns } from "./CollectionsBottomBar.vue?vue&type=template&id=2f68e62f&scoped=true&"
import script from "./CollectionsBottomBar.vue?vue&type=script&lang=js&"
export * from "./CollectionsBottomBar.vue?vue&type=script&lang=js&"
import style0 from "./CollectionsBottomBar.vue?vue&type=style&index=0&id=2f68e62f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f68e62f",
  null
  
)

export default component.exports